<template>
  <div id="app">
    <!--   Contents -->
    <div class="wrappaer">
      <Header />
      <div id="container">
        <router-view></router-view>
      </div>
      <!-- / container -->
      <Footer />
    </div>
    <!-- / wrapper -->
  </div>
</template>
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'
export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  created() {
   
  },
  methods: {

  }
}
</script>
<style lang="scss">
@import './assets/styles/style.scss';
</style>